var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('genelarama',{attrs:{"apiname":"GenelTanitimAra","label":_vm.getLabel,"tip":_vm.tipToInt},model:{value:(_vm.Model),callback:function ($$v) {_vm.Model=$$v},expression:"Model"}})}
var staticRenderFns = []

export { render, staticRenderFns }